import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { SITE } from "@/data/site";

export default function CTABlock() {
  return (
    <section className="relative py-24 md:py-36 bg-[color:var(--bg-dark)] text-white overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 halftone-bg opacity-[0.08] halftone-fade" aria-hidden />
      <div className="absolute -right-40 -top-40 w-[520px] h-[520px] rounded-full bg-[color:var(--accent)]/20 blur-[120px]" aria-hidden />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="max-w-[1080px]"
        >
          <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/60 mb-8">— Ready when you are</div>
          <h2 className="font-display text-[48px] md:text-[112px] leading-[0.95] tracking-[-0.03em]">
            Tell us about your <em className="italic text-[color:var(--accent)]">next print project.</em>
          </h2>
        </motion.div>

        <div className="mt-12 md:mt-16 flex flex-col md:flex-row gap-4 md:gap-6 md:items-center">
          <Link
            to="/quote"
            className="btn-accent inline-flex items-center gap-3 rounded-full pl-7 pr-6 py-4 text-[13px] tracking-[0.18em] uppercase font-medium"
            data-testid="cta-block-quote"
          >
            Request a Free Quote <ArrowUpRight className="w-4 h-4" />
          </Link>
          <a
            href={SITE.phoneHref}
            className="inline-flex items-center gap-3 rounded-full pl-6 pr-6 py-4 text-[13px] tracking-[0.18em] uppercase font-medium border border-white/25 hover:border-white transition-colors"
            data-testid="cta-block-call"
          >
            <Phone className="w-4 h-4" /> Call {SITE.phone}
          </a>
          <a
            href={SITE.emailHref}
            className="inline-flex items-center gap-3 rounded-full pl-6 pr-6 py-4 text-[13px] tracking-[0.18em] uppercase font-medium text-white/80 hover:text-white transition-colors"
            data-testid="cta-block-email"
          >
            <Mail className="w-4 h-4" /> Email Us
          </a>
        </div>
      </div>
    </section>
  );
}
